/**
* @version 1.1
* @changelog
*    1.1 android and ie detection
*/

$(function() {
	var ua = navigator.userAgent;

	var parts = ua.match(/[UNI]; Android (\d+)\.(\d+)/i);
	if (parts) {
		$(document.body).addClass("shitty-android android-"+parts[1]+"-"+parts[2]+" android-"+parts[1]);
	}

	var parts = ua.match(/windows phone.*trident\/7/i);
	if (parts) {
		$(document.body).addClass("mobile-ie-11");
	}

});